import {
    UPDATE_ACCOUNT_YIELD,
    UPDATE_ACCOUNT_YIELD_FAILURE,
    UPDATE_ACCOUNT_YIELD_SUCCESS,
} from 'store/actions/types';
import accoiuntYieldsHelper from 'helpers/accountYields';

export const updateAccountYield = (payload) => {
    const values = accoiuntYieldsHelper.formatToPercentage(payload.values, 'yield');

    const normalised = Object.assign({}, payload, values);

    return {
        type: UPDATE_ACCOUNT_YIELD,
        payload: normalised,
    };
};

export const updateAccountYieldFailure = (error) => {
    return {
        type: UPDATE_ACCOUNT_YIELD_FAILURE,
        error: error,
    };
};

export const updateAccountYieldSuccess = (id, response) => {
    return {
        type: UPDATE_ACCOUNT_YIELD_SUCCESS,
        id: id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/account-yields/updateAccountYields.js